import type { BillingCurrency } from '@contracts/payment/Currency';
import { TransactionCurrency } from '@contracts/payment/Currency';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import type { Billing } from '@src/orders/domain/Billing';
import { CurrencyCell } from '@src/orders/review/CurrencyCell';
import { BorderedTableCell, WideRow } from '@src/orders/review/StyledTableRows';
import { useTranslation } from 'react-i18next';

interface Props {
  currency: BillingCurrency;
  totals: Billing;
}

export const CreditCardTotalRows = ({ currency, totals }: Props) => {
  const { t } = useTranslation();
  const { billingTable } = totals;
  const isBalanceVisible = totals.shouldDisplayTheBalance(billingTable);
  const totalFees = totals.getTotalFees();
  const totalRemaining = totals.getRoundedTotalRemaining();

  return (
    <>
      <WideRow>
        <BorderedTableCell variant="head" align="right">
          {t('reviewBilling.totalOwed')}
        </BorderedTableCell>
        <CurrencyCell
          cellCurrency={TransactionCurrency.CAD}
          currency={currency}
          value={totalFees.CAD}
        />
        <CurrencyCell
          cellCurrency={TransactionCurrency.USD}
          currency={currency}
          value={totalFees.USD}
        />
      </WideRow>
      {isBalanceVisible && (
        <>
          <WideRow>
            <BorderedTableCell variant="head" align="right">
              {t('reviewBilling.totalCollected')}
            </BorderedTableCell>
            <CurrencyCell
              cellCurrency={TransactionCurrency.CAD}
              currency={currency}
              value={billingTable.CAD.totalCollected}
            />
            <CurrencyCell
              cellCurrency={TransactionCurrency.USD}
              currency={currency}
              value={billingTable.USD.totalCollected}
            />
          </WideRow>

          <WideRow selected>
            <BorderedTableCell
              variant="head"
              align="right"
              className={totalRemainingStyle}
            >
              {t('reviewBilling.totalRemaining')}
            </BorderedTableCell>
            <CurrencyCell
              cellCurrency={TransactionCurrency.CAD}
              currency={currency}
              value={totalRemaining!.CAD}
              prefix
              className={totalRemainingStyle}
            />
            <CurrencyCell
              cellCurrency={TransactionCurrency.USD}
              currency={currency}
              value={totalRemaining!.USD}
              prefix
              className={totalRemainingStyle}
            />
          </WideRow>
        </>
      )}
    </>
  );
};

const totalRemainingStyle = css({
  borderTop: `${theme.table.border.secondary}`,
  borderBottom: `${theme.table.border.secondary}`,
});
